import getContentDataSource from '@gameday/core/datasources/helpers/getContentDatasource';

const liveFeedDataRequestAction = () => {
    return (dispatch, getState, { componentDataEngine }) => {
        const state = getState();

        const {
            config: {
                env,
                locale = 'en-US',
                useContentApi = false,
                context: {
                    gameContext = 'mlb'
                } = {},
                enableSummaryFiltersLive: {
                    all,
                    highlights,
                    keyMoments,
                    scoringPlays,
                    homeRuns,
                    strikeouts,
                    hardHits,
                    highLeverage,
                    leadChange,
                    winProb
                } = {}
            },
            gumbo: {
                gamePk
            } = {}
        } = state;

        const {
            name: contentDataSource,
            params: contentParams
        } = getContentDataSource(useContentApi, { gamePk, locale, gameContext, env });

        return Promise.allSettled([
            componentDataEngine.fetch('playMetrics', {
                gamePk,
                all,
                highlights,
                keyMoments,
                scoringPlays,
                homeRuns,
                strikeouts,
                hardHits,
                highLeverage,
                leadChange,
                winProb
            }),
            componentDataEngine.fetch(contentDataSource, contentParams)
        ]).then(([playMetricsRes, contentRes]) => {
            componentDataEngine.store(playMetricsRes.value);
            componentDataEngine.store(contentRes.value);
        });
    };
};

export default liveFeedDataRequestAction;
